'use client';

import { styled } from '../../styles';
import { Popper } from '../Popper';

export const AppDownloaderPopper = styled(Popper)(({ theme }) => ({
  zIndex: theme.zIndex.modal,
  backgroundColor: theme.palette.surface2,
  width: '374px',
  borderRadius: `${theme.shape.borderRadius * 2}px`,
  boxShadow: theme.shadows[2],
}));
